import { ITokenExpiryPair } from "@shared/dto";
import { Constants } from "./Constants";

export class AuthClientUtil {
  public static getRefreshToken(): string | null {
    let refreshToken = localStorage.getItem(Constants.REFRESH_TOKEN_LS);
    if (refreshToken === "undefined") {
      localStorage.removeItem(Constants.REFRESH_TOKEN_LS);
      refreshToken = null;
    }
    return refreshToken;
  }

  public static isITokenExpiryPair(obj: ITokenExpiryPair): obj is ITokenExpiryPair {
    return obj.access_token !== undefined && obj.expires_at !== undefined;
  }
}
